import {
  PayeeRequirement,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";

import { RequirementStatusViewProps } from "../../../../types";

export const getPayoutMethodRequirementPayerStatusCell = (
  requirement: PayeeRequirement
): RequirementStatusViewProps => {
  switch (requirement.status) {
    case RequirementStatus.COMPLETED:
      return {
        pill: {
          text: "Complete",
          theme: "success",
          icon: true
        }
      };
    case RequirementStatus.PENDING_PAYER_REVIEW:
      return {
        pill: {
          theme: "warning",
          text: "Pending",
          icon: true
        }
      };
    default:
      return {
        pill: {
          theme: "warning",
          text: "Action required",
          icon: true
        }
      };
  }
};
